import { render, staticRenderFns } from "./UnreadMessages.vue?vue&type=template&id=9024eeaa&lang=pug&"
import script from "./UnreadMessages.ts?vue&type=script&lang=js&"
export * from "./UnreadMessages.ts?vue&type=script&lang=js&"
import style0 from "./UnreadMessages.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports